import React, { FC } from 'react'
import { FormikConsumer } from 'formik'
import { RegistrationForm } from '../RegistrationForm/RegistrationForm'
import { FormEmailField } from '../../../../formComponents/FormEmailField/FormEmailField'
import { FormFirstNameField } from '../../../../formComponents/FormFirstNameField/FormFirstNameField'
import { FormEducationDirectionField } from '../../../../formComponents/FormEducationDirectionField/FormEducationDirectionField'
import IFormRegistrationValues from '../../../IFormRegistrationValues'
import { FormFieldTypes } from '../../../../../emun/RegistrationFormFieldTypes'
import { IOrganizationsItem } from '../../../../../interfaces/IOrganizationsItem'
import { SocialNetworks } from '../../../../../emun/social'
import { FormLastNameField } from '../../../../formComponents/FormLastNameField/FormLastNameField'
import { FormPasswordField } from '../../../../formComponents/FormPasswordField/FormPasswordField'
import { FormPhoneField } from '../../../../formComponents/FormPhoneField/FormPhoneField'
import { IUserChangeParams } from '../../../../../interfaces/IUserChangeParams'
import { FormSpecialtyField } from '../../../../formComponents/FormSpecialtyField/FormSpecialtyField'
import { FormDegreeField } from '../../../../formComponents/FormDegreeField/FormDegreeField'
import { FormInstituteField } from '../../../../formComponents/FormInstituteField/FormInstituteField'
import { IDegreeItem } from '../../../../../interfaces/IDegreeItem'
import { ISpecialtyItem } from '../../../../../interfaces/ISpecialtyItem'
import { IInstituteItem } from '../../../../../interfaces/IInstituteItem'
import { FormRegionField } from '../../../../formComponents/FormRegionField/FormRegionField'
import { IRegionItem } from '../../../../../interfaces/IRegionItem'

import { IFormValue } from '../../../../../validator/IFormValues'
import { DEGREE_REQUIRED_TEXT } from '../../../../../validator/errorsValidation'

interface IForm17Values extends IFormRegistrationValues {
  [FormFieldTypes.PostStudentOrTeacher]: IOrganizationsItem
  [FormFieldTypes.Specialty]: ISpecialtyItem
  [FormFieldTypes.Degree]: IDegreeItem
  [FormFieldTypes.Institute]: IInstituteItem
  [FormFieldTypes.Region]: IRegionItem
}

const initialForm17Data = {
  [FormFieldTypes.Email]: '',
  [FormFieldTypes.FirstName]: '',
  [FormFieldTypes.LastName]: '',
  [FormFieldTypes.Password]: '',
  [FormFieldTypes.Phone]: '',
  [FormFieldTypes.PostStudentOrTeacher]: { name: '' },
  [FormFieldTypes.Region]: { id: '', name: '' },
  [FormFieldTypes.Specialty]: { id: '', name: '' },
  [FormFieldTypes.Degree]: { id: '', name: '' },
  [FormFieldTypes.Institute]: { id: '', name: '' },
}

type RegistrationForm0Props = {
  onSocialAuth(socialNetwork: SocialNetworks, callbackUrl?: string): void
}

export const onSubmit = (values: IForm17Values): IUserChangeParams => ({
  [FormFieldTypes.Password]: values[FormFieldTypes.Password],
  [FormFieldTypes.Phone]: values[FormFieldTypes.Phone].replace(/\s/g, '').replace('+', ''),
  [FormFieldTypes.FirstName]: values[FormFieldTypes.FirstName].trim(),
  [FormFieldTypes.LastName]: values[FormFieldTypes.LastName].trim(),
  [FormFieldTypes.Email]: values[FormFieldTypes.Email].trim(),
  [FormFieldTypes.Position]: values[FormFieldTypes.PostStudentOrTeacher].name.trim(),
  [FormFieldTypes.Region]: values[FormFieldTypes.Region].id.trim(),
  [FormFieldTypes.Institute]: values[FormFieldTypes.Institute].id.trim(),
  [FormFieldTypes.Specialty]: values[FormFieldTypes.Specialty].id.trim(),
  [FormFieldTypes.Degree]: values[FormFieldTypes.Degree].id.trim(),
})

export const RegistrationForm17: FC<RegistrationForm0Props> = ({ onSocialAuth }) => {
  const validateDegree =
    (_fieldName: string) =>
    async (value: IFormValue): Promise<string> => {
      const val = value as IDegreeItem
      const trimmedValue = val.id?.trim()

      if (!trimmedValue) {
        return DEGREE_REQUIRED_TEXT
      }

      return ''
    }

  return (
    <RegistrationForm onSocialAuth={onSocialAuth} initialFormData={initialForm17Data} onSubmit={onSubmit}>
      <FormFirstNameField />
      <FormLastNameField />
      <FormEmailField />
      <FormPasswordField />
      <FormPhoneField />
      <FormEducationDirectionField />
      <FormRegionField />
      <FormInstituteField />
      <FormSpecialtyField />
      <FormikConsumer>
        {({ values }) =>
          values[FormFieldTypes.PostStudentOrTeacher]?.name?.toLowerCase().includes('студент') && (
            <FormDegreeField validate={validateDegree} />
          )
        }
      </FormikConsumer>
    </RegistrationForm>
  )
}

RegistrationForm17.displayName = 'RegistrationForm17'
